import React from 'react'
import { Dispatch } from 'redux'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import { Close, FileCopyOutlined } from '@material-ui/icons'
import { INotifications } from '../../types/notifications'
import {
  closeNotification,
  triggerNotification,
} from '../../actions/notifications'
import { copyToClipboard } from '../../services/common'
import { StyledMessage, StyledCopyButton } from './styled'
import { useCustomSnackbar } from './hook'
import { NOTIFICATION_TIMEOUT } from '../../config/notifications'

export interface ISnackbar extends INotifications {
  dispatch: Dispatch
}

export const CustomSnackbar = ({
  open,
  message,
  correlationId,
  dispatch,
}: ISnackbar) => {
  const [snackbarMessage, setSnackbarMessage] = useCustomSnackbar()

  setTimeout(() => {
    setSnackbarMessage('')
  }, NOTIFICATION_TIMEOUT)

  const handleClose = (
    e: React.SyntheticEvent<any, Event>,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    dispatch(closeNotification())
    if (!!snackbarMessage) {
      setSnackbarMessage('')
    }
  }

  const handleCopy = (e: React.SyntheticEvent<any, Event>, reason?: string) => {
    copyToClipboard(`${message}\nCorrelation ID: ${correlationId}`, () => {
      handleClose(e, reason)
      setTimeout(() => {
        dispatch(triggerNotification('Copied'))
      })
    })
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open || !!snackbarMessage}
      onClose={handleClose}
      autoHideDuration={NOTIFICATION_TIMEOUT}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={
        <StyledMessage id="snackbar-message">
          {message || snackbarMessage}
        </StyledMessage>
      }
      action={[
        correlationId && (
          <StyledCopyButton
            id="snackbar-copy"
            key="copy"
            aria-label="Copy"
            color="inherit"
            size="small"
            onClick={handleCopy}
          >
            <FileCopyOutlined />
            Copy error
          </StyledCopyButton>
        ),
        <IconButton
          id="snackbar-close-icon"
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={handleClose}
        >
          <Close />
        </IconButton>,
      ].filter(Boolean)}
    />
  )
}
